import React, { useMemo } from "react"

interface iSelectItemProps<T> {
  onClick: (artPiece: T) => void
  isSelected: boolean
  item: T
  children: React.ReactNode
}

const SelectItem = <T,>({
  onClick,
  isSelected,
  item,
  children,
}: iSelectItemProps<T>) => {
  return useMemo(
    () => (
      <div
        onClick={() => onClick(item)}
        className={`${isSelected ? "selected-item" : ""}`}
      >
        {children}
      </div>
    ),
    [isSelected],
  )
}

export default SelectItem
